import React from "react"
import "./footer.css"
//must be used within <Layout>, I suppose

export default () => <div class="footer l-box is-center">
Established 2020-03-14, NCH is a neighborhood community support network in Seattle, WA, USA.
</div>